<template>
  <div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    ...amfx.map("session", "primaryRole")
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/dashboards/DefaultDashboard.vue